import React, { useCallback } from "react";
import NumberFormat from "react-number-format";
import {
  Checkbox,
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
} from "react-bootstrap";

const utils = {
  toPercentage: (x) => `${x.toFixed(1)} %`,

  toCommas: (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),

  renderField: ({ input, label, type, meta: { touched, error } }) => (
    <FormGroup validationState={touched && error ? "error" : "success"}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...input} type={type} />
      <HelpBlock>{touched && error ? error : ""}</HelpBlock>
    </FormGroup>
  ),

  renderCheckbox: ({ input, label }) => (
    <FormGroup>
      <Checkbox {...input}>{label}</Checkbox>
    </FormGroup>
  ),
};

export default utils;

export const PercentageInput = ({ label, ...props }) => {
  const onChange = useCallback(
    ({ floatValue }) => {
      props.input.onChange(floatValue ?? null);
    },
    [props]
  );
  const meta = props.meta;
  const error = meta?.error;
  const validationState = error ? "error" : undefined;
  return (
    <FormGroup id={props.input.name} validationState={validationState}>
      <ControlLabel>{label}</ControlLabel>
      <NumberFormat
        customInput={FormControl}
        value={props.input.value}
        suffix="%"
        onValueChange={onChange}
        allowNegative={false}
        onBlur={props.input.onBlur}
      />
      {error && <HelpBlock>{error}</HelpBlock>}
    </FormGroup>
  );
};

export const NumberInput = ({ label, ...props }) => {
  const onChange = useCallback(
    ({ floatValue }) => {
      props.input.onChange(floatValue ?? null);
    },
    [props]
  );
  const meta = props.meta;
  const error = meta?.error;
  const validationState = error ? "error" : undefined;
  return (
    <FormGroup id={props.input.name} validationState={validationState}>
      <ControlLabel>{label}</ControlLabel>
      <NumberFormat
        customInput={FormControl}
        value={props.input.value}
        onValueChange={onChange}
        thousandSeparator
        allowNegative={false}
        decimalScale={0}
        onBlur={props.input.onBlur}
      />
      {error && <HelpBlock>{error}</HelpBlock>}
    </FormGroup>
  );
};

export const WrappedCheckbox = (props) => {
  return (
    <Checkbox checked={props.input.checked} onChange={props.input.onChange}>
      {props.label}
    </Checkbox>
  );
};
